import { useEffect, useRef, useState } from "react";
import api from "../../../api/api";
import ActionsRoadmap from "../UserRoadmap/ActionsRoadmap/ActionsRoadmapLegacy";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { findFlagRef } from "../UserRoadmap/UserRoadmap";
import * as actions from "../../../store/actions/action";
import styles from "./Type.module.css";
import FlagMapper from "../../../Util/FlagMapper";
import { Button, Skeleton, Tag, message } from "antd";
import Loading from "../../../Components/Loading/Loading";
import { defaultTermsValue } from "../../../Util/defaultValues";
import { PageHeader } from "@ant-design/pro-components";
import { SolutionOutlined } from "@ant-design/icons";
import GenderMapper from "../../../Util/GenderMapper";
const Type = ({ operatorData, ClearLoading, LoadingSetter, loading }) => {
  const flagsRef = useRef();
  const [flags, setFlags] = useState();
  const [terms, setTerms] = useState(defaultTermsValue);
  const [typeData, setTypeData] = useState();
  const [isRoadmapChanged, setIsRoadmapChanged] = useState(false);
  const params = useParams();
  const mapPreAndPostConditionFlags = (
    targetFlag,
    preConditionFlags,
    postConditionFlags,
    newFlags
  ) => {
    if (
      targetFlag.preConditionFlags.length === 0 &&
      targetFlag.postConditionFlags.length === 0
    ) {
      return;
    }
    const mapPreConditionFlags = (flag) => {
      flag.preConditionFlags.forEach((el) => {
        const flagRef = findFlagRef(el, flags);
        if (flagRef) {
          flagRef.preConditionGenerated = flag;
          flagRef.addedUser = operatorData;
          flagRef.addedDate = new Date();
          newFlags.splice(flags.indexOf(flagRef), 1);
          preConditionFlags.push(flagRef);
          if (
            Array.isArray(flagRef.preConditionFlags) &&
            flagRef.preConditionFlags.length > 0
          ) {
            setTimeout(() => {
              mapPreConditionFlags(flagRef);
            }, 1);
          }
          if (
            Array.isArray(flagRef.postConditionFlags) &&
            flagRef.preConditionFlags.length > 0
          ) {
            setTimeout(() => {
              mapPostConditionFlags(flagRef);
            }, 1);
          }
        }
      });
    };
    const mapPostConditionFlags = (flag) => {
      flag.postConditionFlags.forEach((el) => {
        const flagRef = findFlagRef(el, newFlags);
        if (flagRef) {
          flagRef.postConditionGenerated = flag;
          flagRef.addedUser = operatorData;
          flagRef.addedDate = new Date();
          newFlags.splice(newFlags.indexOf(flagRef), 1);
          postConditionFlags.push(flagRef);
          if (
            Array.isArray(flagRef.preConditionFlags) &&
            flagRef.preConditionFlags.length > 0
          ) {
            setTimeout(() => {
              mapPreConditionFlags(flagRef);
            }, 3);
          }
          if (
            Array.isArray(flagRef.postConditionFlags) &&
            flagRef.preConditionFlags.length > 0
          ) {
            setTimeout(() => {
              mapPostConditionFlags(flagRef);
            }, 3);
          }
        }
      });
    };
    if (targetFlag.preConditionFlags.length > 0) {
      mapPreConditionFlags(targetFlag);
    }
    if (targetFlag.postConditionFlags.length > 0) {
      mapPostConditionFlags(targetFlag);
    }
  };

  const loadData = () => {
    api
      .get("/flags", { params:{ all:true }})
      .then((res) => {
        const data = res.data;
        setFlags(data);
        flagsRef.current = JSON.parse(JSON.stringify(res.data));
        ClearLoading();
      })
      .then(() => {
        ClearLoading();
        loadTerms();
      })
      .catch(() => {
        ClearLoading();
      });
  };
  const loadTerms = () => {
    api.get("roadmaptypes/" + params.id).then((res) => {
      setTypeData(res.data);
      setTerms(res.data.flagsRoadmap);
    });
  };
  const removeUsedFlags = (roadmap) => {
    if (flagsRef.current && terms) {
      let allUserFlags = Object.keys(terms).map((key) => {
        return terms[key].flags;
      });
      if (roadmap) {
        allUserFlags = Object.keys(roadmap).map((key) => {
          return roadmap[key].flags;
        });
      }
      const editedFlags = Array.from(flagsRef.current)
        .map((flag) => {
          let userFlagIsUsed = false;
          allUserFlags.forEach((flagArr) => {
            Array.from(flagArr).forEach((userFlag) => {
              if (userFlag && flag) {
                if (userFlag?.id === flag?.id) {
                  userFlagIsUsed = true;
                }
              }
            });
          });
          return userFlagIsUsed ? null : flag;
        })
        .filter((el) => el !== null);
      setFlags(editedFlags);
    }
  };
  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    removeUsedFlags();
  }, [typeData]);

  const onSave = () => {
    LoadingSetter();
    api
      .put("/roadmaptypes/roadmap/" + params.id, { flagsRoadmap: terms })
      .then((res) => {
        // console.log(res.data);
        message.success("ذخیره نقشه راه موفقیت آمیز بود.");
        setIsRoadmapChanged(false);
        ClearLoading();
      })
      .catch(() => {
        ClearLoading();
        message.error("ذخیره با مشکل مواجه شد.");
      });
  };
  return (
    <>
      {
        <PageHeader
          avatar={{ icon: <SolutionOutlined /> }}
          title={typeData ? typeData.title : <Skeleton.Button active />}
          extra={
            <>
              <Button
                loading={loading}
                onClick={onSave}
                disabled={typeData ? false : true}
                type="primary"
                style={{ backgroundColor: "green" }}
                className={[
                  isRoadmapChanged ? styles.FlashingSaveButton : null,
                ].join(" ")}
              >
                ذخیره
              </Button>
            </>
          }
        />
      }
      <div className={styles.Type}>
        <ActionsRoadmap
          flags={flags}
          flagsRef={flagsRef.current}
          globalSearch={""}
          isRoadmapChanged={isRoadmapChanged}
          mapPreAndPostConditionFlags={mapPreAndPostConditionFlags}
          setIsRoadmapChanged={setIsRoadmapChanged}
          setFlags={setFlags}
          roadmapId={typeData ? params.id : null}
          setTerms={setTerms}
          terms={terms}
        />
        <div className={styles.TypeData}>
          {typeData ? (
            <>
              <h2>اطلاعات تایپ</h2>

              {/* prev description data */}
              {typeData.description && (
                <div className={styles.TypeDataItem}>
                  <h3>توضیحات: </h3>
                  <div>{typeData.description}</div>
                </div>
              )}

              {/* prev age data */}
              {typeData.age && (
                <div className={styles.TypeDataItem}>
                  <h3>سن: </h3>
                  <div>{typeData.age}</div>
                </div>
              )}

              {/* prev age data */}
              {typeData.gender && (
                <div className={styles.TypeDataItem}>
                  <h3>جنسیت: </h3>
                  <div>{GenderMapper(typeData.gender)}</div>
                </div>
              )}

              {(typeData?.types ?? [])
                .filter(
                  (e) => e.question && e.value && e.question !== "product"
                )
                .map((el, i) => (
                  <div key={i} className={styles.TypeDataItem}>
                    <h3>{el.question}:</h3>
                    <div>{el.value}</div>
                  </div>
                ))}

              {(typeData?.area ?? [])?.length !== 0 && (
                <div className={styles.TypeDataItem}>
                  <h3>حوزه‌های کلیدی: </h3>
                  <div>
                    {Array.isArray(typeData.area) &&
                      typeData.area.map((a) => {
                        return <Tag>{FlagMapper(a).title}</Tag>;
                      })}
                  </div>
                </div>
              )}

              {(typeData?.period ?? [])?.length !== 0 && (
                <div className={styles.TypeDataItem}>
                  <h3>بازه‌های زمانی: </h3>
                  <div>
                    {Array.isArray(typeData.period) &&
                      typeData.period.map((a) => {
                        return <Tag>{a}</Tag>;
                      })}
                  </div>
                </div>
              )}

              <div className={styles.TypeDataItem}>
                <h3>صفت‌ها: </h3>
                <div>
                  {Array.isArray(typeData.tag) &&
                    typeData.tag?.map((a) => {
                      return <Tag>{a}</Tag>;
                    })}
                </div>
              </div>
            </>
          ) : (
            <Loading />
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    operatorData: state.userData,
    loading: state.loading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Type);
